import { StorageObjectVersion } from "../../../services/api/instances/storageApi/types/object_types";
import { StorageObjectValue } from "../../../services/api/instances/storageApi/types/service_types";

export const getLatestDateVersionValue = <T extends StorageObjectValue>(
  versions: StorageObjectVersion<T>[],
) =>
  versions.reduce((latest, current) =>
    new Date(current.version_date as string) >
    new Date(latest.version_date as string)
      ? current
      : latest,
  );
